"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeliveryInfoPanelCms = void 0;
var DeliveryInfoPanelCms = /** @class */ (function () {
    function DeliveryInfoPanelCms() {
        this.shippingInfoLabel = 'Delivery info';
        this.attentionLabel = 'Attention';
        this.dtvnDelivery = 'This delivery info applies to your TV cart items only.';
        this.shippingAddressText = 'Shipping address';
        this.continueLabel = 'Continue';
        this.shipSameAsService = 'Shipping address must be same as service address';
    }
    return DeliveryInfoPanelCms;
}());
exports.DeliveryInfoPanelCms = DeliveryInfoPanelCms;
//# sourceMappingURL=deliveryInfoPanel.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/components/panels/DeliveryInfoPanel/deliveryInfoPanel.cms.js
// module id = 1995
// module chunks = 8